import apiUrl from "./config/config";
import axios from "axios";

class unitApi {

  //Get all units
  static async getUnits(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "unit", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}

export default unitApi;
